<template lang="">
  <div>
    <div class="search ">
      <el-form :model="searchForm" class="demo-form-inline" size="small" label-width="80px">
        <el-col :span="5" class="formWidth">
          <el-form-item label="作品名称">
            <el-input v-model="searchForm.casename" placeholder="作品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth">
          <el-form-item label="活动名称">          
            <el-select v-model="searchForm.competitionid" clearable placeholder="活动名称" @change="GetAwardType(searchForm.competitionid)">
              <el-option v-for="item in activityList" :label="item.abbrname" :key="item.competitionid" :value="item.competitionid" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" class="formWidth">
          <el-form-item label="奖项分类">
            <el-cascader ref="prizetypeTree" :key="Date.now()" v-model="searchForm.prizeTypeSelect" :options="prizeTypeList" @change="changeTypeid(searchForm.prizeTypeSelect)" :props="defaultProps" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth">
          <el-form-item label="奖项名称">          
            <el-select v-model="searchForm.awardid"  clearable placeholder="奖项名称">
              <el-option v-for="item in prizeList" :label="item.awardname" :value="item.awardid" :key="item.awardid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth">
          <el-form-item label="公司名称">
            <el-input v-model="searchForm.company" placeholder="公司全称或简称关键词"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7" class="formWidth">
          <el-form-item label="" label-width="30px">
            <el-radio-group v-model="searchForm.type">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">图文</el-radio-button>
              <el-radio-button label="2">视频</el-radio-button>
              <el-radio-button label="3">图文+视频</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="formWidth" v-if="userInfo.role==3">
          <el-form-item label="" label-width="15px">
            <el-radio-group v-model="searchForm.has">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">已打分[{{has}}]</el-radio-button>
              <el-radio-button label="2">未打分[{{not}}]</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        
        <el-col :span="9"  v-if="userInfo.role==1||userInfo.role==4" class="formWidth" style="float:right;text-align: right;;">
          <el-form-item label-width="15px">
            <el-button type="primary" @click="search()"><i class="fa fa-search"></i> 查 询</el-button>
            <el-button type="success" @click="exportExcel" v-if="userInfo.role==1||userInfo.role==4"><i class="fa fa-table"></i> 导 出</el-button>
            <el-button type="danger" @click="search()" v-if="userInfo.role==1||userInfo.role==4"><i class="fa fa-refresh"></i> 刷 新</el-button>
            <el-button type="warning" @click="getJudgesScore()" v-if="userInfo.role==1||userInfo.role==4"><i class="fa fa-tasks"></i> 评分进度</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="3" v-else class="formWidth" style="float:right;text-align: right;;">
          <el-form-item label-width="15px">
            <el-button type="primary" @click="search()"><i class="fa fa-search"></i> 查 询</el-button>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="3" class="formWidth" style="float: right;text-align: right;;">
          <el-form-item label="" label-width="0px">
            <el-dropdown >
              <el-button type="primary" size="small">
                批操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item>
                <el-dropdown-item>双皮奶</el-dropdown-item>
                <el-dropdown-item>蚵仔煎</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          
        </el-col> -->
        
        <div class="clear"></div>
      </el-form>

    </div>
    <div class="clear"></div>
    <!-- <hr /> -->
    <div class="list " v-if="false" v-loading="loading">
        <ul v-if="!pc">
          <li v-for="item in list">
            <div class="list_left">
              <!-- <div class="checkbox"><el-checkbox :v-model="false">&nbsp;</el-checkbox></div> -->
              <div>
                <p>                  
                  <span class="workname"><i class="fa fa-bookmark-o"></i>{{item.casename}}</span>
                  <b><span class="worktype" title="作品类别"><i :class="item.type==1?'fa fa-file-pdf-o':'fa fa-file-video-o'"></i>{{item.type|filterType}}</span>
                  <span class="workstatus" title="状态"><i class="fa fa-arrow-right"></i>{{item.casebookstatus|filterStatus}}</span></b>
                </p>
                <p>
                  <span class="workprize" title="申报活动"><i class="fa fa-leaf"></i>{{item.comname}}</span>
                  <b><span class="workprize" title="申报奖项"><i class="fa fa-trophy"></i>{{item.awardname}}</span></b>
                </p>
                <p>
                  <b><span class="workdate" title="提交时间"><i class="fa fa-clock-o"></i>{{item.bookctime|filterStamp}}</span>
                  <span class="workprize" :title="'申报公司：'+item.company"><i class="fa fa-certificate"></i>{{item.abbreviation}}</span></b>
                </p>
              </div>
            </div>
            <div class="list_right">
              <el-button v-if="item.IsShow" size="mini" @click="viewfile(item)">查看</el-button>
              <el-button v-if="item.IsApproved" size="mini" type="success" plain @click="setpass(item,1)">审核通过</el-button>
              <el-button v-if="item.IsApproved" size="mini" type="primary" plain @click="setpass(item,0)">审核不通过</el-button>
              <el-button v-if="item.IsGrade" size="mini" type="warning" plain >打分</el-button>
            </div>
          </li>
        </ul>
        <table v-if="false" class="table table-highlight table-border table-hover table-striped align-center ">
          <thead>
            <tr>
              <th>案例名称</th>
              <th>参报企业</th>
              <th>类型</th>
              <!-- <th>联系人</th>
              <th>电话</th>
              <th>职位</th> -->
              <th>参报活动</th>
              <th>参报奖项</th>
              <th>状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list">
              <td class="align-left " :title="item.casename" ><div class="oneRow">{{item.casename}}</div></td>
              <td class="align-left" :title="item.company"><div class="">{{item.abbreviation}}</div></td>
              <td>{{item.type|filterType}}</td>
              <!-- <td></td>
              <td></td>
              <td></td> -->
              <td class="align-left " :title="item.comname"><div class="">{{item.comname}}</div></td>
              <td class="align-left " :title="item.awardname"><div class="">{{item.awardname}}</div></td>
              <td>{{item.casebookstatus|filterStatus}}</td>
              <td class="oper">
                <span v-if="item.IsShow"><a href="javascript:void(0)" @click="viewfile(item)">查看</a></span>
                <span v-if="item.IsApproved"> | <a href="javascript:void(0)" @click="tocheck(item)">审核</a></span>
                <span v-if="item.IsGrade"> | <a href="javascript:void(0)" @click="">打分</a></span>
              </td>
            </tr>
          </tbody>
        </table>
        <el-table v-if="pc" class="highlight" border :data="list" stripe style="width: 100%" @sort-change="sortChange">
          <el-table-column prop="casebookid" label="id" width="60" fixed></el-table-column>
          <el-table-column prop="casename" label="案例名称" show-overflow-tooltip width="200"></el-table-column>
          <el-table-column prop="awardname" label="参报奖项" show-overflow-tooltip width="200">
            <template slot-scope="scope">
              <p v-html="scope.row.awardname"></p>
            </template>
          </el-table-column>
          <el-table-column prop="member_total" v-if="userInfo.role==3" label="分数" show-overflow-tooltip align="right" width="50"></el-table-column>
          <el-table-column prop="total" label="总分" sortable="custom" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="80">
            <template slot-scope="scope">
              {{scope.row.total}}
            </template>
          </el-table-column>
          <el-table-column prop="avg_score" label="平均分" sortable="custom" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="90">
            <template slot-scope="scope">
              {{scope.row.avg_score|avgFilter}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="已评/总数" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="80">
            <template slot-scope="scope">
              {{scope.row.total_num}}/{{scope.row.member_num}}
            </template>
          </el-table-column>
          <el-table-column prop="introduction" label="案例简介" show-overflow-tooltip width="120"></el-table-column>           
          <el-table-column prop="casebookstatus" label="状态" width="100"  v-if="userInfo.role==1||userInfo.role==4">
            <template slot-scope="scope">
              <i v-if="scope.row.copyright" title="已上传版权证明" style="margin-right:0" class="fa fa-certificate"></i>{{scope.row.casebookstatus|filterStatus}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="参报活动" show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <p :title="scope.row.comname">{{scope.row.abbrname}}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="abbreviation" label="参报企业"  show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <p :title="scope.row.company">{{scope.row.abbreviation}}</p>
            </template>
          </el-table-column> -->
          <el-table-column prop="company_title" label="公司名称"  show-overflow-tooltip  width="120" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="company_name" label="提报公司"  show-overflow-tooltip  width="120" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="company_type" label="提报公司身份" width="95" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="70" label="类型">
            <template slot-scope="scope">
              {{scope.row.type|filterType}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="typename" label="奖项分类" show-overflow-tooltip width="120"></el-table-column> -->
          <!-- <el-table-column prop="company_name" label="提报公司" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="company_type" label="提报公司身份" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="" label="联合品牌主" width="82" align="center">
            <template slot-scope="scope">
              {{scope.row.is_union_brand|filterUnionbrand}}
            </template>
          </el-table-column>
          <el-table-column prop="brand_name" label="品牌名称" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="push_media" label="投放媒体" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="" label="投放时间" show-overflow-tooltip width="165">
            <template slot-scope="scope">
              {{scope.row.release_time_start}} <i v-if="scope.row.release_time_start">至</i> {{scope.row.release_time_end}}
            </template>
          </el-table-column> -->
          <el-table-column prop="linkman" label="联系人" width="" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="linkphone" label="联系电话" width="90" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="position" label="职位" show-overflow-tooltip width="" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="" label="操作" width="120" class-name="oper" fixed="right" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.button.view"><a href="javascript:void(0)" @click="viewfile(scope.row)">查看</a></span>
              <span v-if="scope.row.button.score"> | <a href="javascript:void(0)" @click="rate(scope.row)"><b v-if="scope.row.member_total>0">已</b>打分</a></span>
              <span v-if="scope.row.button.detail"> | <a href="javascript:void(0)" @click="getscore(scope.row)">分数</a></span>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <el-pagination v-if="false" background layout="slot, prev, pager, next, jumper" :total="total" :current-page="searchForm.page" @current-change="current_change" :page-size="searchForm.length">
      <span>共 <b class="text-danger">{{total}}</b> 条记录，<b class="text-danger">{{total_company}}</b> 个企业</span>
    </el-pagination>

    <el-tabs v-loading="loading" v-model="activeType" element-loading-text="拼命加载中">
      <el-tab-pane v-for="(item,index) in list" :label="item.item_name" :key="item.typeid" :name="item.item_name">

        <el-table class="highlight list" :ref="'multipleTable'+index" stripe border :data="item.children" @sort-change="sortChange" style="width: 100%" row-key="item_id" max-height="500px" default-expand-all>
          <!-- <el-table-column type="selection" width="30" align="center" fixed :selectable='selectEnable'></el-table-column> -->
          <el-table-column label="id" prop="item_id" type="" width="80" fixed="left"></el-table-column>
          <el-table-column label="作品名称" width="350" prop="item_name" fixed="left" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="rank" v-if="scope.row.won_award==0 && scope.row.rank==1" :title="scope.row.rank_name"><i class="fa fa-trophy text-warning"></i><i class="fa fa-trophy text-gray"></i></span>
              <span class="rank" v-if="scope.row.rank==2" :title="scope.row.won_award_name"><i class="fa fa-trophy text-tong"></i></span>
              <span class="rank" v-if="scope.row.rank==3" :title="scope.row.won_award_name"><i class="fa fa-trophy text-youxiu"></i></span>
              <span class="rank" v-if="scope.row.won_award==3" :title="scope.row.won_award_name"><i class="fa fa-trophy text-gray"></i></span>
              <span class="rank" v-if="scope.row.won_award==2" :title="scope.row.won_award_name"><i class="fa fa-trophy text-warning"></i></span>
              <span class="rank" v-if="scope.row.won_award==1" :title="scope.row.won_award_name"><i class="fa fa-trophy text-warning"></i><i class="fa fa-diamond text-info"></i></span>
              <span :class="(scope.row.item_type!='case')?'text-primary':''">{{scope.row.item_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="member_total" v-if="userInfo.role==3" label="分数" show-overflow-tooltip align="right" width="80"></el-table-column>
          <el-table-column prop="total" label="总分" sortable="custom" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="80">
            <template slot-scope="scope">
              {{scope.row.total}}
            </template>
          </el-table-column>
          <el-table-column prop="avg_score" label="平均分" sortable="custom" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.item_type=='case'"> {{scope.row.avg_score|avgFilter}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="已评/总数" v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip align="right" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.item_type=='case'">{{scope.row.total_num}}/{{scope.row.member_num}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="introduction" label="案例简介" show-overflow-tooltip width="120"></el-table-column>            -->
          <!-- <el-table-column prop="casebookstatus" label="状态" width="100"  v-if="userInfo.role==1||userInfo.role==4">
            <template slot-scope="scope">
              <i v-if="scope.row.copyright" title="已上传版权证明" style="margin-right:0" class="fa fa-certificate"></i>{{scope.row.casebookstatus|filterStatus}}
            </template>
          </el-table-column> -->
          <el-table-column prop="" label="参报活动" show-overflow-tooltip width="140">
            <template slot-scope="scope">
              <p :title="scope.row.comname">{{scope.row.abbrname}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="abbreviation" label="参报企业" v-if="userInfo.role==1||userInfo.role==4"  show-overflow-tooltip width="120">
            <template slot-scope="scope">
              <p :title="scope.row.company">{{scope.row.abbreviation}}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="company_title" label="公司名称"  show-overflow-tooltip  width="120" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="company_name" label="提报公司"  show-overflow-tooltip  width="120" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="company_type" label="提报公司身份" width="95" v-if="userInfo.role==1||userInfo.role==4"></el-table-column> -->
          <el-table-column prop="" label="类型" width="100">
            <template slot-scope="scope">
              {{scope.row.type|filterType}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="typename" label="奖项分类" show-overflow-tooltip width="120"></el-table-column> -->
          <el-table-column prop="company_name" label="提报公司" show-overflow-tooltip  v-if="userInfo.role==1||userInfo.role==4" width="120"></el-table-column>
          <el-table-column prop="company_type" label="提报公司身份" show-overflow-tooltip  v-if="userInfo.role==1||userInfo.role==4" width="100"></el-table-column>
          <el-table-column prop="" label="联合品牌主" width="82"  v-if="userInfo.role==1||userInfo.role==4" align="center">
            <template slot-scope="scope">
              {{scope.row.is_union_brand|filterUnionbrand}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="brand_name" label="品牌名称"  v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip width="100"></el-table-column>
          <el-table-column prop="push_media" label="投放媒体"  v-if="userInfo.role==1||userInfo.role==4" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="" label="投放时间"  v-if="userInfo.role==1||userInfo.role==4" align="center" show-overflow-tooltip width="180">
            <template slot-scope="scope">
              {{scope.row.release_time_start}} <i v-if="scope.row.release_time_start">至</i> {{scope.row.release_time_end}}
            </template>
          </el-table-column> -->
          <el-table-column prop="linkman" label="联系人" show-overflow-tooltip width="80" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="linkphone" label="联系电话" width="90" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="position" label="职位" show-overflow-tooltip width="" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>
          <el-table-column prop="address" label="公司地址" show-overflow-tooltip width="220" v-if="userInfo.role==1||userInfo.role==4"></el-table-column>           
          <el-table-column label="操作" align="center" prop="" fixed="right" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.button.view"><a href="javascript:void(0)" @click="viewfile(scope.row)">查看</a></span>
              <span v-if="scope.row.button.score && scope.row.member_total>0 "> | <a href="javascript:void(0)" @click="rate(scope.row)">分数</a></span>
              <span v-if="scope.row.button.detail"> | <a href="javascript:void(0)" @click="getscore(scope.row)">分数</a></span>
              <span v-if="scope.row.button.rank"> | <a href="javascript:void(0)" @click="goup(scope.row,index)">晋级</a></span>
            </template>
          </el-table-column>
        </el-table>

      </el-tab-pane>
    </el-tabs>

    <!-- 查看作品 -->
    <el-dialog title="查看作品" :visible.sync="viewDialog" :width="dialogWidth1" top="5vh" @close="clearView">
      <div>
        <div class="" style="line-height: 2;margin-bottom:1em;">
          <p>作品名称：{{viewFile.casename}}</p>
          <!-- <p>作品简介：{{viewFile.introduction}}</p> -->
        </div>
        <div style="height:70vh;width:100%;-webkit-overflow-scrolling: touch;overflow-y: auto;" v-loading="score_loding">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;" class="viewcontent">
              <el-tab-pane label="基本信息" name="info">
                <div class="basicinfo">
                  <p><span class="text-primary">作品名称：</span>{{viewFile.casename}}</p>             
                  <p><span class="text-primary">作品简介：</span>{{viewFile.introduction}}</p>    
                  <p><span class="text-primary">公司名称：</span>{{viewFile.company_title}}</p>    
                  <p><span class="text-primary">提报公司：</span>{{viewFile.company_name}}</p>    
                  <p><span class="text-primary">提报公司身份：</span>{{viewFile.company_type}}</p>
                  <p><span class="text-primary"  style="vertical-align: top;">参报奖项：</span><span v-html="viewFile.awardname" style="display: inline-block;"></span></p>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="viewFile.type==1||viewFile.type==3" label="图文" name="pdf">                
                <iframe :src="'/awards/pdf/web/viewer.html?file='+imgBase+viewFile.file_list[0].url+'#page=1'" width="100%" :style="viewpdfHeight" ref="" id="" frameborder="0"></iframe>
              </el-tab-pane>
              <el-tab-pane v-if="viewFile.type==2||viewFile.type==3" label="视频" name="mp4" style="text-align: center;height:100%;">
                <video v-if="viewFile.type==2" :src="imgBase+viewFile.file_list[0].url" style="max-width: 100%;max-height:100%;" preload controls x5-playsinline="true" playsinline="true" webkit-playsinline="true"></video>
                <video v-if="viewFile.type==3" :src="imgBase+viewFile.file_list[1].url" style="max-width: 100%;max-height:100%;" preload controls x5-playsinline="true" playsinline="true" webkit-playsinline="true"></video>
              </el-tab-pane>
              <el-tab-pane v-if="rateInfo.show" label="打分" name="rate">
                <el-form :model="rateInfo" ref="rateInfo" size="small" label-width="160px" style="width:800px;margin:auto;">
                  <el-form-item label="作品总分" style="padding-bottom:6px;">
                    <p>{{totalScore}}</p>
                  </el-form-item>
                  <el-form-item  v-for="item,index in rateInfo.items" :key="item.item_id" :label="item.item_name+' [满分'+item.max_score+']'">
                    <el-slider style="padding-left:10px" :disabled="(Number(rateInfo.total)==0)?false:true" v-model="item.score" :max="item.max_score" input-size="mini" show-input></el-slider>
                    <span></span>
                  </el-form-item>
                  <el-form-item v-if="rateInfo.total==0" label="推荐奖项" >          
                    <el-tree
                      :data="prizeTypeList2"
                      show-checkbox
                      node-key="typeid"
                      ref="treeForm"
                      :check-strictly="true"
                      :default-checked-keys="prizeTypeArr"
                      :default-expanded-keys="prizeTypeArr"
                      auto-expand-parent
                      @check-change="handleNodeClick"
                      :props="defaultProps">
                    </el-tree>
                  </el-form-item>
                  <el-form-item v-else label="推荐奖项" prop="awards_name" >
                    <p v-html="rateInfo.awards_name"></p>
                  </el-form-item>
                  <el-form-item label="案例点评" prop="comment">
                    <el-input :disabled="(rateInfo.total==0)?false:true" type="textarea" rows="5" v-model="rateInfo.comment"  maxlength="500" show-word-limit></el-input>
                  </el-form-item>
                  <div style="text-align: right;"><el-button size="small" v-if="rateInfo.total==0" type="primary" @click="setScore('rateInfo')" ><i class="fa fa-check"></i> 确 定</el-button></div>
                  <div class="clear"></div>
                </el-form>                
              </el-tab-pane>
            </el-tabs>
        </div> 
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="viewDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 作品打分 -->
    <el-dialog title="作品打分" :visible.sync="rateDialog"  :width="dialogWidth" :close-on-click-modal="false">
      <div>
        <el-form :model="rateInfo" size="small" label-width="160px">
          <el-form-item label="作品总分" style="padding-bottom:6px;">
            <p>{{totalScore}}</p>
          </el-form-item>
          <el-form-item v-for="item,index in rateInfo.items" :key="item.item_id" :label="item.item_name+' [满分'+item.max_score+']'">
            <el-slider style="padding-left:10px" :disabled="(Number(rateInfo.total)==0)?false:true" v-model="item.score" :max="item.max_score" input-size="mini" show-input></el-slider>
            <span></span>
          </el-form-item>
          <el-form-item label="推荐奖项" prop="awards_name" :rules="{ type: 'array',required: true, message: '请填写', trigger: 'change' }">
            <p v-html="rateInfo.awards_name"></p>
          </el-form-item>
          <el-form-item label="案例点评" prop="comment">
            <el-input :disabled="(rateInfo.total==0)?false:true" type="textarea" rows="10" v-model="rateInfo.comment"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="rateDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
        <el-button size="small" v-if="rateInfo.total==0" type="primary" @click="setScore('rateInfo')"><i class="fa fa-check"></i> 确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看分数 -->
    <el-dialog title="查看分数" :visible.sync="scoreDialog" width="1000px" :close-on-click-modal="false">
      <div>
        <p>
          总分：<span class="text-primary">{{scoreobj.total_score}}</span>，
          平均分：<span class="text-primary">{{scoreobj.avg_score}}</span>，
          最高分：<span class="text-primary">{{scoreobj.max_score}}</span>，
          最低分：<span class="text-primary">{{scoreobj.min_score}}</span>，
          已打分评委：<span class="text-primary">{{scoreobj.total_num}}</span>位        
        </p>
        <el-table v-if="scorelist.length>0" class="highlight" border :data="scorelist" stripe style="width: 100%;" max-height="500" :row-class-name="tableRowClassName">
          <el-table-column prop="member_name" label="评委" width="" align="center"></el-table-column>
          <el-table-column prop="" v-for="(item,index) in scorelist[0].items" align="center" :label="item.item_name" :key="item.id">
            <template slot-scope="scope">
              <span>{{scope.row.items[index].score}}</span>
             </template>
          </el-table-column>
          <el-table-column prop="total_score" label="总分" width="" align="center"></el-table-column>
          <el-table-column prop="awards" label="推荐奖项" width="250" align="left">
            <template slot-scope="scope">
              <p v-html="scope.row.awards"></p>
             </template>
          </el-table-column>
          <el-table-column prop="comment" show-overflow-tooltip label="作品点评" width="150" align="left"></el-table-column>
        </el-table>
        <p v-else style="text-align: center;">尚未有评委打分</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="scoreDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 评分进度 -->
    <el-dialog title="评分进度" :visible.sync="JudgesDialog" width="800px" :close-on-click-modal="false"  top="5vh" @close="">
      <div v-loading="judgesLoading">
        <ul class="judgesScoreList">
          <li v-for="item in judgesScoreList" :key="item.id">
            <el-avatar :size="80" :src="imgBase+item.filephoto"></el-avatar>
            <!-- <el-avatar :size="70" src="http://dev.maad.award.com/storage/topic/202107/06475de12a102e73329be87510f945e7.jpg"></el-avatar> -->
            <p>{{item.name}}</p>
            <p class="bar"><span :style="'width:'+item.mix+'%'" :title="item.mix+'%'"></span></p>
            <p>{{item.has_num}}/{{item.total_num}}</p>
            <p style="font-size:.8em">{{item.mix}}%</p>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="JudgesDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
        <el-button size="small" type="primary" @click="getJudgesScore()"><i class="fa fa-refresh"></i> 刷 新</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import * as API from "@/api/main"
import * as D from '@/utils/download'
export default {
  data(){
    return {
      total:0,
      total_company:0,
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      searchForm:{
        competitionid: 14,
        page:1,
        length:15,
        casebookstatus:"",
        type:"",
        awardid:"",
        prizeTypeSelect:[],
        has:"",
      },
      list:[],
      treelist:[],
      activityList:[],
      prizeTypeList:[],
      prizeTypeList2:[],
      prizeList:[],
      viewDialog:false,
      viewFile:{
        name:"",
        type:"",
        url:"",
      },
      dialogWidth1:"1100px",
      dialogWidth:"700px",
      pc:true,
      rateDialog:false,//打分面板
      defaultProps: {
        children: 'children',
        label: 'typename',
        value:'typeid',
      },
      activeName:"info",
      viewpdfHeight:"height:calc( 70vh - 50px )",
      rateInfo:{
        awards:[],
      },//打分表单
      totalScore:0,
      userInfo:JSON.parse(localStorage.getItem("user")),
      scoreDialog:false,//查看分数面板
      scorelist:[],//评分列表
      scoreobj:{},//评分项目
      activeType:'年度单项奖/年度案例大奖',//默认选中
      has:0,//已打分
      not:0,//未打分
      activityInfo:{},
      prizeTypeArr:[],
      judgesScoreList:[],//评委打分进度列表
      JudgesDialog:false,//打分进度面板
      judgesLoading:false,//评分进度loading
      score_loding:false,
    }
  },
  watch:{

    "searchForm.casebookstatus":{
      handler: function() {
        this.search()
      },      
    },    

    "searchForm.type":{
      handler: function() {
        this.search()
      },      
    },

    'rateInfo.items':{
      handler:function(newValue){
        this.totalScore=0;
        for(var i=0;i<newValue.length;i++){
          this.totalScore+=Number(newValue[i].score);
          // console.log(newValue[i].score)
        }
      },
      deep:true,
    },

    "searchForm.has":{
      handler: function() {
        this.search()
      },      
    },

    'rateInfo.awards':{
      handler:function(newValue){
        // console.log(newValue)
      },
      deep:true,
    },

  },
  
  filters:{

    //作品状态
    filterStatus(status){
      let str="";
      switch(status){
        case 1:
          str = "未审核";
          return str;
          break;
        case 2:
          str = "审核通过";
          return str;
          break;
        case 3:
          str = "审核不通过";
          return str;
          break;
        default:
          return str;
          break;
      }      
    },

    //平均分
    avgFilter(value){
      return Number(value).toFixed(2);
    },

    //作品类型
    filterType(value){
      if(value==1){
        return "图文"
      }else if(value==2){
        return "视频"
      }else if(value==3){
        return "图文+视频"
      }else{
        return ""
      }
    },

    //时间戳转字符串
    filterStamp(timestamp){
      // var t = '1617239226';
      var d = new Date(timestamp * 1000);    //根据时间戳生成的时间对象
      var datetime = (d.getFullYear()) + "-" + 
                (((d.getMonth() + 1)<10)?'0'+(d.getMonth() + 1):(d.getMonth() + 1)) + "-" +
                ((d.getDate())<10?'0'+(d.getDate()):(d.getDate()))+ " " + 
                ((d.getHours())<10?'0'+(d.getHours()):(d.getHours()))+ ":" +
                ((d.getMinutes())<10?'0'+(d.getMinutes()):(d.getMinutes()))+ ":" +
                ((d.getSeconds())<10?'0'+(d.getSeconds()):(d.getSeconds()))
      return datetime;
    },

    //是否
    filterUnionbrand(value){
      return (value)?"是":"否"
    }

  },
  methods: {
    //获取列表
    getlist(){
      this.loading=true;
      this.searchForm.is_export=0;
      API.GetScoreList(this.searchForm).then(res=>{
        this.list=res.data.list;
        this.loading=false;
        // this.total=res.data.total;
        this.total_company=res.data.total_company;
        this.has=res.data.has;
        this.not=res.data.not;
        this.activeType=this.list[0].item_name;
      })
    },
    getlist2(){
      this.loading=true;
      this.searchForm.is_export=0;
      API.GetScoreList(this.searchForm).then(res=>{
        this.list=res.data.list;
        this.loading=false;
        // this.total=res.data.total;
        this.total_company=res.data.total_company;
        this.has=res.data.has;
        this.not=res.data.not;
      })
    },

    //获取奖项列表
    getPrize(){
      let id=this.searchForm.competitionid;
      if(id){
        API.GetPrizeListByAct({competitionid:id}).then(res=>{        
            this.prizeList=res.data;      
          // console.log(res)
        })
      }else{
        this.searchForm.awardid=""
        this.prizeList=[];
      }
      
    },

    //获取活动列表
    getActivityList(){
      this.loading=true;
      let postdata={
        page:1,
        length:100,
        status:"",
      }
      API.GetActivityList(postdata).then(res=>{
        this.activityList=res.data.data;
      })
    },

    //分页
    current_change(currentPage){
      // console.log(currentPage)
      this.searchForm.page = currentPage;
      this.getlist();
    },

    //查询
    search(){
      // this.current_change(1);
      this.getlist();
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    //查看文件
    viewfile(item){
      this.viewFile=item;
      this.viewDialog=true;
      this.rateInfo={
        cbawid:item.cbawid,
        total:item.member_total,
        items:_.cloneDeep(item.items),
        show:item.button.score,
        awards:item.awards,
        awards_name:item.awards_name,
        comment:item.comment,
      };
      // this.$refs.treeForm.setCheckedKeys([]);
      // this.$refs['rateInfo'].resetFields();
    },

    //清除查看
    clearView(){
      // console.log(this.viewFile)
      this.activeName="info";
      this.viewFile={};
      // console.log(this.viewFile)
      if(this.$refs.rateInfo){
        this.$refs.treeForm.setCheckedKeys([]);
        this.resetForm('rateInfo');
        this.prizeTypeArr=[];
        let nodeDatas = this.$refs.treeForm.store.nodesMap
        // 循环所有节点，将需要收起的节点数据的 expanded 属性设置为false
        for (let key in nodeDatas) {
          nodeDatas[key].expanded = false;
        }
      }
    },

    //打开审核
    tocheck(item){
      this.viewFile=item;
      this.checkDialog=true;
    },

    //初审通过不通过
    setpass(item,type){
      if(type){
        this.$confirm('确定将“'+item.casename+'”通过审核?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.SetWorkPass({casebookid:item.casebookid}).then(res=>{        
            this.$message({
              message: '作品审核通过',
              type: 'success',
            })
            this.getlist();
            this.checkDialog=false;
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          });          
        });
      }else{
        this.$prompt('请输入审核不通过的原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^[\s\S]*.*[^\s][\s\S]*$/,
          inputErrorMessage: '必须输入原因'
        }).then(({ value }) => {
          API.SetWorkUnPass({casebookid:item.casebookid,fail_reason:value}).then(res=>{        
            this.$message({
              message: '作品审核不通过',
              type: 'success',
            })
            this.getlist();
            this.checkDialog=false;
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审核'
          });          
        });
      }
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth1="100vw";
        this.dialogWidth="100vw";
      }
    },

    //获取分类列表
    GetAwardType(id){
      this.prizeTypeList=[];
      this.searchForm.typeid="";
      this.searchForm.awardid="";
      this.prizeList=[]
      this.searchForm.prizeTypeSelect=[];
      if(id){        
        API.GetAwardTypeList({competitionid:id}).then(res=>{
          this.prizeTypeList=res.data;
          // console.log(this.prizeTypeList);
        })
      }      
    },

    //search获取typeID
    changeTypeid(arr){
      console.log(arr)
      this.searchForm.awardid="";
      if(arr.length>0){
        this.searchForm.typeid=arr[arr.length-1];
        var obj=this.$refs["prizetypeTree"].getCheckedNodes()[0].data;
        this.prizeList=_.cloneDeep(obj.awards)
      }else{
        this.prizeList=[]
        this.searchForm.typeid="";
      }
    },

    //查看切换选项卡
    handleClick(){
      this.viewpdfHeight="0";
      setTimeout(() => {
        this.viewpdfHeight="height:calc( 70vh - 50px )";
      }, 0);
      if(this.activeName=="rate"){
        this.$refs.treeForm.setCheckedKeys([]);
        this.resetForm('rateInfo');
      }
    },

    //打分
    rate(item){
      this.rateInfo={
        cbawid:item.cbawid,
        total:item.member_total,
        items:_.cloneDeep(item.items),
        show:item.button.score,
        awards:item.awards,
        awards_name:item.awards_name,
        comment:item.comment,
      };
      // console.log(this.rateInfo);
      this.rateDialog=true;
    },

    //保存打分
    setScore(formName){
      // API.DoScore(this.rateInfo).then(res=>{
      //   this.getlist();
      //   this.rateDialog=false;
      // })
      console.log(this.totalScore)
      if(this.totalScore>0){
        this.score_loding=true;
        //this.$refs[formName].validate((valid) => {
          // if (valid) {
            this.$confirm('评委老师请注意：作品一旦打分，将无法进行修改，请各位评审老师谨慎提交。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              API.DoScore(this.rateInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.score_loding=false;
                this.getlist2();
                // this.$refs.treeForm.setCheckedKeys([]);
                this.rateDialog=false;
                this.viewDialog=false;
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });   
            });
          // } else {
          //   return false;
          // }
        //})
      }else{
        this.$message({
          message: '您还没有打分哦，请您打分！',
          type: 'warning'
        });
      }
    },

    //查看分数
    getscore(item){
      // API.GetScoreDetail({cbawid:item.cbawid}).then(res=>{
      //   this.scorelist=_.cloneDeep(res.data.data);
      //   this.scoreobj=_.cloneDeep(res.data);
      //   this.scoreDialog=true;
      // })
      API.GetScoreDetail({cbawid:item.cbawid}).then(res=>{
        this.scorelist=_.cloneDeep(res.data.data);
        this.scoreobj=_.cloneDeep(res.data);
        this.scoreDialog=true;
      })
    },

    //分数排序
    sortChange(item){
      console.log(item);
      this.searchForm.sort_value=item.order;
      this.searchForm.sort_type=item.prop;
      this.search();
    },

    //导出Excel
    exportExcel: _.debounce(function () {
      this.loading = true
      this.searchForm.is_export=1;
      D.down( "/index/score/index" , this.searchForm ).then(response => {
        D.load( response , "作品评分列表.xlsx" )
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }, 500),

    //获取奖项树
    getPrizeType(id,n){
      API.GetAwardType({competitionid:id,is_data:1,is_disabled:n}).then(res=>{
        this.prizeTypeList2=_.cloneDeep(res.list);
        this.rateInfo.awards=[];
      })
    },

    //树
    handleNodeClick(data, checked, node) {
      // console.log(this.$refs.treeForm.getCheckedKeys());
      // this.prizeList=[];
      this.rateInfo.awards=[];
      this.rateInfo.awards=_.cloneDeep(this.$refs.treeForm.getCheckedKeys())
      // console.log(this.rateInfo.awards);
    },

    //最高分最低分
    tableRowClassName({row, rowIndex}) {
      if (row.m == 1) {
        return 'warning-row';
      } else if (row.m == 2) {
        return 'danger-row';
      }
      return '';
    },

    //获取评分进度
    getJudgesScore(){
      this.judgesLoading=true;
      this.JudgesDialog=true;
      API.GetJudgesProgress({competitionid:this.searchForm.competitionid}).then(res=>{
        this.judgesScoreList=res.data;
        // console.log(this.judgesScoreList)
        this.judgesLoading=false;
      })
    }

  },
  created() {
    this.getlist();
    this.getActivityList();
    this.diffrentScreen();
    this.GetAwardType(this.searchForm.competitionid)
    this.getPrizeType(this.searchForm.competitionid,1);
    if(document.body.clientWidth>1200){
      this.pc=true;
    }else{
      this.pc=false;
    }

  },
}
</script>
<style scoped>
  .search{padding-bottom:20px;}
  .oneRow{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:200px;}
.list {line-height: 2;;}
.list ul li{display:flex;justify-content:space-between;align-items:center;padding:10px;border-bottom: 1px solid #e7e7e7;}
.list ul li:nth-of-type(even){    background: #f6f6f6;}
.list ul li:hover{background:var(--mainColorOp)}
.list .list_left{display: flex;}
.list .list_left .checkbox{margin-right:5px;}
.list i.fa{color:var(--mainColor);margin-right:5px;width:16px;text-align: center;display: inline-block;}
.list span.workname{font-size:1em;}
.list span.workprize u{color:#999;}
.list td.oper span{margin:0;}
.basicinfo{background-color: var(--mainColorOp);padding:2em 3em;line-height: 2;border-radius: 4px;}
.judgesScoreList{display: flex;flex-wrap: wrap;max-height:70vh;overflow-y: auto;}
  .judgesScoreList li{width:12.5%;text-align: center;padding:1em 0;}
  .judgesScoreList li p.bar{width:90%;height:8px;overflow:hidden;display: flex;background:#ccc;border-radius:20px;margin:auto;;}
  .judgesScoreList li p.bar span{background:var(--mainColor);display: inline-block;height:100%;border-radius:20px;}
@media screen and (max-width: 1200px){
  .formWidth{width:100%;}
  .list ul li{display: block;}
  .list_right{padding-left:15px;}
  .list b{display:block;}
}
</style>